export const equipments = (state) => state.equipment1.equipments
export const oneEquipment = (state) => state.equipment1.oneEquipment
export const branches = (state) => state.equipment1.branches
export const harmful = (state) => state.equipment1.harmful
export const equipmentSelect = (state) => state.equipment1.equipmentSelect
export const notification = (state) => state.equipment1.notification

